<div class="page-wrapper">
  <div class="page-header">
    <h1>{{ "settings" | i18n }}</h1>
  </div>
  <div class="page-content">
    <ng-container
      *ngIf="(customer$ | async) && (updatedFields$ | async) as updatedFields">
      <div
        *ngIf="updatedFields.bookingWebHook"
        class="card-box">
        <h1 class="card-title">
          {{ "bookingWebHookTitle" | i18n }}
        </h1>
        <p>
          {{ "bookingWebHookDescription" | i18n }}
        </p>

        <mat-form-field class="light-form-field">
          <mat-label>{{ "bookingWebHookUrl" | i18n }}</mat-label>
          <input
            matInput
            [(ngModel)]="updatedFields.bookingWebHook.url"
            (ngModelChange)="onBookingWebHookChange()"
            name="bookingWebHookUrl"
            type="text"
            autocomplete="off"
            data-cy="super-admin-settings-booking-webhook-url"
            placeholder="https://example.com/webhook" />
        </mat-form-field>

        <mat-form-field class="light-form-field api-key-field">
          <mat-label>{{ "bookingWebHookApiKey" | i18n }}</mat-label>
          <input
            matInput
            [(ngModel)]="updatedFields.bookingWebHook.apiKey"
            (ngModelChange)="onBookingWebHookChange()"
            name="bookingWebHookApiKey"
            type="text"
            autocomplete="new-password"
            data-cy="super-admin-settings-booking-webhook-api-key"
            [placeholder]="
              updatedFields.bookingWebHook.apiKeyPreview || 'Enter API key'
            " />
          <mat-hint
            *ngIf="
              updatedFields.bookingWebHook.apiKeyPreview &&
              !updatedFields.bookingWebHook.apiKey
            ">
            {{ "bookingWebHookApiKeyCurrent" | i18n }}
            {{ updatedFields.bookingWebHook.apiKeyPreview }}
            ({{ "bookingWebHookApiKeyLeaveEmpty" | i18n }})
          </mat-hint>
        </mat-form-field>

        <button
          mat-raised-button
          color="primary"
          (click)="saveSuperAdminCustomerSettings()"
          data-cy="super-admin-settings-save-button">
          {{ "save" | i18n }}
        </button>
      </div>
    </ng-container>
  </div>
</div>
